import { SxProps } from '@mui/system';

export const StyledShortcutListSx: SxProps = {
  gridArea: '2 / 1 / 3 / auto',
  listStyle: 'none',
  margin: 0,
  padding: 0,
  position: 'relative',
  paddingTop: '8px',
  paddingBottom: '8px',
  maxWidth: '200px',
  overflow: 'auto',
  boxShadow: 'inset -1px -1px 0px rgba(0, 0, 0, 0.12)',
};

export const StyledListItemSx: SxProps = {
  cursor: 'pointer',
  fontSize: '13px',
  fontWeight: 300,
  '&:hover': {
    backgroundColor: 'rgba(29, 75, 122, 0.04)',
  },
};
